<div class="form-group">
    <label>{{Title}}<span *ngIf="!isrequired" class='optional'> (optional)</span></label>
    <input name="Phone" class="form-control" (input)="update($event.target.value)" [formControl]="phoneCtrl"
        placeholder="{{Title}}" [textMask]="{mask: mask, guide:false}" />
    <div class="error" *ngIf="(form.submitted || phoneCtrl.dirty) && phoneCtrl.invalid">
        <p *ngIf="phoneCtrl.errors['required']">{{requiredErrorMessage}}</p>
        <p *ngIf="phoneCtrl.errors['minlength'] || phoneCtrl.errors['maxlength']">{{Title}} is invalid</p>
    </div>
</div>